import type { Profile } from '@libs/data-access/queries'
import {
  authService,
  profileSchema,
  queryClientOptions
} from '@libs/data-access/queries'
import { routes } from '@spa/core/router/appRoutesConfig'
import { useQueryClient } from '@tanstack/react-query'
import { authCacheKeys } from 'libs/data-access/queries/src/lib/queries/Auth/auth.cacheKeys'
import { useNavigate } from 'react-router-dom'

export const isProfileValid = (profile: unknown): profile is Profile => {
  return profileSchema.safeParse(profile).success
}

export const useAccountCreation = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const getDraftAccountQuery = authService.useGetDraftAccount({
    staleTime: queryClientOptions.time.STATIC
  })
  const updateDraftAccountMutation = authService.usePutDraftAccount()

  const updateDraftData = async (newProfileData: Partial<Profile>) => {
    const currentProfile =
      getDraftAccountQuery.data?.draft_account_form_data?.profile

    const updatedProfile = {
      ...currentProfile,
      ...newProfileData
    }

    await updateDraftAccountMutation.mutateAsync({
      payload: {
        payload: {
          profile: updatedProfile
        }
      }
    })
  }

  const handleProfileComplete = async () => {
    await queryClient.invalidateQueries({
      queryKey: authCacheKeys.draftAccount()
    })

    navigate(routes.accountCreationCompanyInfo.path, { replace: true })
  }

  const handleCompanyComplete = async () => {
    navigate(routes.welcome.path, { replace: true })
  }

  return {
    handleCompanyComplete,
    handleProfileComplete,
    updateDraftData,
    isFetchingDraftAccountData: getDraftAccountQuery.isFetching,
    profile: getDraftAccountQuery.data?.draft_account_form_data?.profile,
    email: getDraftAccountQuery.data?.info?.email
  }
}
